import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Segment} from 'semantic-ui-react';

import _ from 'lodash';
import {BarChart, Bar, XAxis, YAxis, ReferenceLine, ResponsiveContainer, Legend, Label} from 'recharts';

import {showDollarAmountWithDollar} from 'common/utils';

export class StackedBarChart extends Component {
  constructor(props) {
    super(props);

    this.renderCustomBarLabel = this.renderCustomBarLabel.bind(this);
    this.state = {
      active: -1,
      mileStones: [],
      loading: true,
      selectedBar: null,
    };
  }

  filterChange = (ms) => {
    this.props.onFilterChange(ms);
  };

  onHover = (result) => {
    this.setState({active: result});
  };

  renderCustomBarLabel = ({payload, x, y, width, height, value}) => {
    const {active} = this.state;
    const {mileStoneSummary, mileStoneArray} = this.props;
    const mileStone = mileStoneSummary[0];

    return (
      <text y={y} textAnchor="right" dy={-6}>{`${
        mileStoneArray[active]
      }: ${showDollarAmountWithDollar(mileStone[active])}`}</text>
    );
  };

  render() {
    const {active} = this.state;
    const {mileStoneSummary, target, sum, mileStoneArray, color} = this.props;
    const maxDomain = target > sum ? target : sum;

    const bar = _.map(mileStoneArray, (res, i) => (
      <Bar
        stroke="white"
        dataKey={i}
        label={active == i ? this.renderCustomBarLabel : null}
        stackId="a"
        fill={color[i]}
        onClick={() => this.filterChange(i)}
        onMouseOver={() => this.onHover(i)}
        onMouseOut={() => this.onHover(-1)}
        />
    ));
    const legendPayload = _.map(mileStoneArray,(res,i)=>{
      return {'value': res, 'type':'square', 'id':i, 'color':color[i]}
    })
    return (
      <Segment className="barChart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            layout="vertical"
            data={mileStoneSummary}
            margin={{top: 20, bottom: 20, left: 20, right: 20}}
          >
            <XAxis hide type="number" domain={[0, maxDomain]} />
            <YAxis hide type="category" />
            <Legend verticalAlign="bottom" payload={legendPayload}/>

            {bar}

            <ReferenceLine x={target} stroke="black" strokeWidth="2">
              <Label value="Target" position="top"/>
            </ReferenceLine>
          </BarChart>
        </ResponsiveContainer>
      </Segment>
    );
  }
}
